import type { SVGProps } from 'react'

const Question = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 10C3 13.866 6.13401 17 10 17C13.866 17 17 13.866 17 10C17 6.13401 13.866 3 10 3C6.13401 3 3 6.13401 3 10ZM4.4 10C4.4 6.90721 6.90721 4.4 10 4.4C13.0928 4.4 15.6 6.90721 15.6 10C15.6 13.0928 13.0928 15.6 10 15.6C6.90721 15.6 4.4 13.0928 4.4 10ZM10.3833 10.7462C10.3441 11.001 10.1383 11.2264 9.85412 11.2264H9.77572C9.49152 11.2264 9.28572 11.0108 9.24652 10.7462L9.14852 10.0798C9.09952 9.7564 9.28572 9.531 9.59932 9.4918C10.4519 9.384 10.8439 9.1194 10.8439 8.6392V8.6196C10.8439 8.1786 10.5107 7.9238 9.94232 7.9238C9.52092 7.9238 9.15832 8.0512 8.80552 8.3158C8.68792 8.404 8.53112 8.4726 8.36452 8.4726C7.99212 8.4726 7.67852 8.159 7.67852 7.7866C7.67852 7.6004 7.75692 7.4044 7.93332 7.2574C8.45272 6.8262 9.10932 6.5518 9.97172 6.5518C11.3829 6.5518 12.3433 7.277 12.3433 8.5804V8.6C12.3433 9.8446 11.4809 10.3542 10.4127 10.5698L10.3833 10.7462ZM8.92312 12.7258V12.7062C8.92312 12.2358 9.28572 11.8732 9.77572 11.8732C10.2657 11.8732 10.6283 12.2358 10.6283 12.7062V12.7258C10.6283 13.1962 10.2657 13.5588 9.77572 13.5588C9.28572 13.5588 8.92312 13.1962 8.92312 12.7258Z"
        fill="currentColor"
      />
    </svg>
  )
}
export default Question
